'use client';

import React from 'react';
import { v4 as uuidV4 } from 'uuid';
// import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import { usePathname, useSearchParams } from 'next/navigation';
import GlobalContext from '@/context/globalContext';
import { LOGIN_ROUTER_PATH, PRODUCTION_HOST } from '@/constants/router-path';
import {
  getCookie,
  getSessionStorage,
  setCookie,
  setSessionStorage,
} from '@/utils/storage';
import { sendEvent, useIntersectionObserver } from '@/utils/site-track';
import { isTimeStamp } from '@/utils/common-utils';

const SiteTrack = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams()?.toString() || '';

  const [trackObserverElements, setTrackObserverElements] = React.useState<
    Element[]
  >([]);
  const [historyUrl, setHistoryUrl] = React.useState<string[]>([]);

  const hasMoved = React.useRef(false);
  const hasFirstVisited = React.useRef(false);
  // const hasScrolled_25 = React.useRef(false);
  // const hasScrolled_50 = React.useRef(false);
  // const hasScrolled_75 = React.useRef(false);

  // const trackScroll = React.useCallback(
  //   debounce(() => {
  //     const scrollPosition = window.scrollY + window.innerHeight;
  //     const scrollHeight = document.documentElement.scrollHeight;
  //     const scrollPercentage = (scrollPosition / scrollHeight) * 100;
  //     if (scrollPercentage >= 25 && !hasScrolled_25.current) {
  //       hasScrolled_25.current = true;
  //       sendEvent({ name: 'scroll_25' });
  //     }
  //     if (scrollPercentage >= 50 && !hasScrolled_50.current) {
  //       hasScrolled_50.current = true;
  //       sendEvent({ name: 'scroll_50' });
  //     }
  //     if (scrollPercentage >= 75 && !hasScrolled_75.current) {
  //       hasScrolled_75.current = true;
  //       sendEvent({ name: 'scroll_75' });
  //     }
  //   }, 300),
  //   [],
  // );

  const trackMove = React.useCallback(
    throttle(() => {
      if (!hasMoved.current) {
        setCookie('_bi', Date.now().toString());
        hasMoved.current = true;
        sendEvent({ name: 'move' });
      }
    }, 300),
    [],
  );

  useIntersectionObserver(trackObserverElements);

  React.useEffect(() => {
    const referrer = document.referrer;
    const isLoginUrl = referrer.includes(window.origin + LOGIN_ROUTER_PATH);
    if (referrer) {
      if (!isLoginUrl) {
        GlobalContext.setContext('referer', referrer);
        setHistoryUrl([referrer]);
      } else {
        const beforeLoginUrl = sessionStorage.getItem('before_login_referer');
        if (beforeLoginUrl) {
          GlobalContext.setContext('referer', beforeLoginUrl);
          setHistoryUrl([beforeLoginUrl]);
        }
        sessionStorage.removeItem('before_login_referer');
      }
    }
    const cid = getCookie('cid');
    if (!hasFirstVisited.current && !cid) {
      hasFirstVisited.current = true;
      const cid = uuidV4().replaceAll('-', '');
      const sid = uuidV4().replaceAll('-', '');
      sessionStorage.setItem('cid', cid);
      sessionStorage.setItem('sid', sid);
      sendEvent({ name: 'first_visit' });
    }
    const session_start = getSessionStorage('session_start');
    if (!session_start) {
      setSessionStorage('session_start', Date.now().toString());
      sendEvent({ name: 'session_start' });
    }
    const _bi = getCookie('_bi');
    const isValidDate = _bi && isTimeStamp(_bi);
    if (!hasMoved.current && !isValidDate) {
      document.addEventListener('mousemove', trackMove);
      document.addEventListener('touchmove', trackMove);
    } else {
      hasMoved.current = true;
      document.removeEventListener('mousemove', trackMove);
      document.removeEventListener('touchmove', trackMove);
    }
    return () => {
      hasMoved.current = false;
      document.removeEventListener('mousemove', trackMove);
      document.removeEventListener('touchmove', trackMove);
    };
  }, []);

  React.useEffect(() => {
    if (pathname) {
      const renderEle = document.querySelector('body div');
      if (!renderEle) {
        return;
      }
      historyUrl.length > 0 &&
        GlobalContext.setContext('referer', historyUrl[historyUrl.length - 1]);
      const currentUrl = document.URL;
      const isLoginUrl = currentUrl.includes(window.origin + LOGIN_ROUTER_PATH);
      !isLoginUrl && setHistoryUrl((prev) => [...prev, currentUrl]);
      if (window.location.host === PRODUCTION_HOST) {
        const url = searchParams ? `${pathname}?${searchParams}` : pathname;
        try {
          (window as any)._hmt.push(['_trackPageview', url]);
        } catch (e) {}
      }
      sendEvent({ name: 'page_view' });
      // document.addEventListener('scroll', trackScroll);
      const obsElements = document.querySelectorAll('[data-observer-id]');
      setTrackObserverElements(obsElements as any);
    }
    return () => {
      // hasScrolled_25.current = false;
      // hasScrolled_50.current = false;
      // hasScrolled_75.current = false;
      // document.removeEventListener('scroll', trackScroll);
    };
  }, [pathname, searchParams]);

  return null;
};

export default SiteTrack;
